<template>
  <div class="col-8">
    <slot />
  </div>
</template>
